/* @generated from adl module ferovinum.datacontracts.invoicelineitem */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface InvoiceLineItemRawRecord {
  id: common_strings.StringNE;
  invoiceId: common_strings.StringNE;
  code: string;
  description: string;
  quantity: common.BigDecimal;
  quantitySuffix: (string|null);
  unitPrice: common.BigDecimal;
  vatPc: (common.BigDecimal|null);
  subtotal: common.BigDecimal;
  discountAmount: (common.BigDecimal|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeInvoiceLineItemRawRecord(
  input: {
    id: common_strings.StringNE,
    invoiceId: common_strings.StringNE,
    code: string,
    description: string,
    quantity: common.BigDecimal,
    quantitySuffix: (string|null),
    unitPrice: common.BigDecimal,
    vatPc: (common.BigDecimal|null),
    subtotal: common.BigDecimal,
    discountAmount: (common.BigDecimal|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): InvoiceLineItemRawRecord {
  return {
    id: input.id,
    invoiceId: input.invoiceId,
    code: input.code,
    description: input.description,
    quantity: input.quantity,
    quantitySuffix: input.quantitySuffix,
    unitPrice: input.unitPrice,
    vatPc: input.vatPc,
    subtotal: input.subtotal,
    discountAmount: input.discountAmount,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const InvoiceLineItemRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.invoicelineitem","decl":{"annotations":[{"value":{"datasetName":"raw_invoice_line_item"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"quantitySuffix","default":{"kind":"nothing"},"name":"quantitySuffix","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"unitPrice","default":{"kind":"nothing"},"name":"unitPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"vatPc","default":{"kind":"nothing"},"name":"vatPc","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"subtotal","default":{"kind":"nothing"},"name":"subtotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"discountAmount","default":{"kind":"nothing"},"name":"discountAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"InvoiceLineItemRawRecord","version":{"kind":"nothing"}}};

export const snInvoiceLineItemRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.invoicelineitem", name:"InvoiceLineItemRawRecord"};

export function texprInvoiceLineItemRawRecord(): ADL.ATypeExpr<InvoiceLineItemRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceLineItemRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.invoicelineitem.InvoiceLineItemRawRecord" : InvoiceLineItemRawRecord_AST
};
